import React from "react";

const VideoSection = () => {
  // Convert YouTube Shorts URL to embed format
  // https://youtube.com/shorts/qikFGfws7RY?si=-dZiFSth-A-CsbyZ
  // becomes: https://www.youtube.com/embed/qikFGfws7RY
  const videoId = "qikFGfws7RY";
  const embedUrl = `https://www.youtube.com/embed/${videoId}`;

  return (
    <section className="py-20 bg-white">
      <div className="max-w-[1200px] mx-auto px-5">
        <div className="text-center mb-12">
          <h2 className="font-playfair text-3xl md:text-[2.5rem] font-bold text-[#222] mb-4">
            How to Register?
          </h2>
          <p className="text-lg text-[#555] max-w-[600px] mx-auto">
            Watch how to create your profile on Select Proposal
          </p>
        </div>
        
        <div className="flex justify-center">
          <div className="relative w-full max-w-4xl aspect-video rounded-xl overflow-hidden shadow-2xl">
            <iframe
              className="w-full h-full"
              src={embedUrl}
              title="Select Proposal - How It Works"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
